var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('p',[_c('a',{attrs:{"href":"https://www.dahe.cn/"}},[_vm._v("技术支持：大河网")])])])}]

export { render, staticRenderFns }